import OneSignal from "react-onesignal"
import { onesignal } from "../config"

// A OneSignal mantém uma lista de external ids bloqueados — "1" responde 400
// "external_id is blocked" — e essa lista já mudou ao menos uma vez. O prefixo
// tira o sistema dessa dependência. O backend envia para o mesmo formato.
const PREFIXO_EXTERNAL_ID = "infocloud-"

const externalIdDoUsuario = usuarioId => `${PREFIXO_EXTERNAL_ID}${usuarioId}`

class OneSignalHelper {
  usuarioPendente = null
  escutandoInscricao = false

  initialize = () => {
    return OneSignal.init(onesignal.options)
  }

  // Grava o vínculo usuário↔inscrição e confirma que ficou gravado. Sem a
  // confirmação, uma falha de gravação passa despercebida e o usuário vira um
  // inscrito sem external_id, inalcançável pelo envio de push do backend.
  async vincularUsuario(userId) {
    const externalId = externalIdDoUsuario(userId)
    try {
      if ((await OneSignal.getExternalUserId()) === externalId) {
        return true
      }

      await OneSignal.setExternalUserId(externalId)

      const gravado = await OneSignal.getExternalUserId()
      if (gravado !== externalId) {
        console.error("OneSignal: external_id não gravado", { esperado: externalId, gravado })
        return false
      }
      return true
    } catch (error) {
      console.error("OneSignal: falha ao vincular usuário", error)
      return false
    }
  }

  // O prompt de permissão aparece depois do login, então no momento do login o
  // navegador normalmente ainda não está inscrito. Este ouvinte fecha essa
  // corrida: assim que o usuário aceita, o vínculo é gravado.
  escutarInscricao() {
    if (this.escutandoInscricao) {
      return
    }
    this.escutandoInscricao = true

    OneSignal.on("subscriptionChange", async inscrito => {
      if (inscrito && this.usuarioPendente) {
        await this.vincularUsuario(this.usuarioPendente)
      }
    })
  }

  // Chamado no login e também no boot, quando a sessão vem do redux-persist e
  // não passa por loginSuccess.
  async setUserData(user) {
    if (!user || !user.id) {
      console.error("OneSignal: usuário sem id, vínculo não realizado", user)
      return
    }

    this.usuarioPendente = String(user.id)
    this.escutarInscricao()

    // Sem consultar isPushNotificationsEnabled antes: ele responde false mesmo
    // com a permissão concedida e a inscrição válida no servidor (reproduzido no
    // Firefox), e foi por isso que os inscritos ficavam sem vínculo. Gravar é
    // idempotente, então vale tentar sempre.
    await this.vincularUsuario(this.usuarioPendente)
  }

  async removerUserData() {
    this.usuarioPendente = null
    try {
      await OneSignal.removeExternalUserId()
    } catch (error) {
      console.error("OneSignal: falha ao remover vínculo do usuário", error)
    }
  }
}

let _onesignalHelper = null

const initOneSignalHelper = () => {
  if (!_onesignalHelper) {
    _onesignalHelper = new OneSignalHelper()
  }
  return _onesignalHelper
}

const getOneSignalHelper = () => {
  return _onesignalHelper
}

export { initOneSignalHelper, getOneSignalHelper }
